module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pageReady) ? _c('div', {
    staticClass: "page collection-page mx-5 margin-top-header"
  }, [_c('content-top-header', {
    staticClass: "mt-3 black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', [_c('li', {
    staticClass: "active"
  }, [_c('label', {
    staticClass: "innerBold"
  }, [_vm._v("\n\t\t\t\t\t\t\tCollection >\n\t\t\t\t\t\t")])]), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        'active ': _vm.isActiveTab(tab.id)
      },
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "innerBold",
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  })], 2)])], 2), _vm._v(" "), _c('repost-music', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'music'),
      expression: "activeTab === 'music'"
    }],
    attrs: {
      "tracks": this.tracks,
      "getCollections": _vm.getCollections,
      "playlists": this.playlist_data.playlists.filter(function (c) { return c.playlist_type == 'tracks'; }),
      "openDeletePlaylistModal": _vm.openDeletePlaylistModal
    },
    on: {
      "methodThatForcesUpdate": _vm.methodThatForcesUpdate
    }
  }), _vm._v(" "), _c('repost-videos', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'videos'),
      expression: "activeTab === 'videos'"
    }],
    attrs: {
      "streams": _vm.streams,
      "getCollections": _vm.getCollections,
      "playlists": this.playlist_data.playlists.filter(function (c) { return c.playlist_type == 'streams'; }),
      "openDeletePlaylistModal": _vm.openDeletePlaylistModal
    },
    on: {
      "methodThatForcesUpdate": _vm.methodThatForcesUpdate
    }
  }), _vm._v(" "), _c('repost-products', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'products'),
      expression: "activeTab === 'products'"
    }],
    attrs: {
      "products": _vm.products,
      "getCollections": _vm.getCollections,
      "playlists": this.playlist_data.playlists.filter(function (c) { return c.playlist_type == 'products'; }),
      "openDeletePlaylistModal": _vm.openDeletePlaylistModal
    },
    on: {
      "methodThatForcesUpdate": _vm.methodThatForcesUpdate
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_delete_playlist_modal),
      callback: function($$v) {
        _vm.show_delete_playlist_modal = $$v
      },
      expression: "show_delete_playlist_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n          Delete Playlist\n        ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n          Are you sure you want to delete this track from playlist?\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deletePlaylist()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1)], 1) : _c('div', {
    staticClass: "page-loader"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/loader.gif"),
      "alt": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6c45a68","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/collection/index.vue
// module id = 1873
// module chunks = 180